<template>
  <div class="create-announcement">
    <div class="loader" v-if="loading"></div>
    <h1>Create Announcement</h1>

    <form ref="form">
      <div style="width: 100%" class="flex">
        <label style="width: 100%">
          Title:
          <input name="title" type="text" v-model="title" required maxlength="255"/>
          <div :style="{ color: charLimit(), width: '50px', 'margin-left': 'auto', 'text-align': 'right' }">
            <div style="font-size: 0.8em; position: relative; font-weight: normal; top: 10px;">{{title.length}}/255</div>
          </div>
        </label>
      </div>

      <div class="flex-top-align mt-2" style="width: 90%">
        <!-- <div style="margin: 0px; font-weight: bold">Regions:</div> -->
        <div>
          <label style="font-weight: 500">
            <input
              class="ml-2"
              type="checkbox"
              v-model="selectAll"
              @change="toggleAllRegions"
            />
            <img
              :src="this.all"
              style="height: 30px; margin-inline: 10px"
              title="All"
            />
          </label>
          <label
            style="font-weight: 500"
            v-for="region in regions"
            :key="region.id"
          >
            <input
              class="ml-2"
              type="checkbox"
              :disabled="selectAll"
              v-model="selectedRegions"
              :value="region.id"
              @change="toggleSelectRegionsPrompt"
            />
            <img
              :src="getRegionsImage(region.name)"
              style="height: 30px; margin-inline: 10px"
              :title="region.name"
            />
            <!-- {{ region.name }} -->
          </label>
        </div>
      </div>

      <div class="flex">
        <label>
          Start Date:
          <input name="start_date" type="date" v-model="startDate" required />
        </label>

        <label>
          End Date:
          <input id="endDateEle" name="end_date" type="date" v-model="endDate" required />
        </label>
      </div>

      <div>
        <label>Body:</label>
        <p style="font-size: 0.8em;"><em>Minimum resolution for optimal image display is:  <b>534 x 300</b></em> </p>
        <div
          style="min-height: 320px; height: 100%"
          id="editor"
          ref="editor"
          :required="true"
        ></div>
      </div>
    </form>

    <div style="display: flex" class="buttons mt-4 mb-4">
      <button style="margin-right: auto" class="preview-btn" @click="goBack">
        Cancel
      </button>
      <button
        class="preview-btn"
        @click="firePreview"
        :disabled="isPreviewDisabled()"
      >
        Preview
      </button>
      <button
        style="margin-left: 20px; position: relative; margin-right: 0px"
        @click="saveAnnouncement"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Quill from 'quill';
import Delta from 'quill-delta';
import Swal from 'sweetalert2';
import all from '../assets/all.png';
import australia from '../assets/australia.png';
import china from '../assets/china.png';
import hongkong from '../assets/hong-kong.png';
import india from '../assets/india.png';
import japan from '../assets/japan.png';
import malaysia from '../assets/malaysia.png';
import philippines from '../assets/philippines.png';
import singapore from '../assets/singapore.png';

export default {
  data() {
    return {
      all: all,
      australia: australia,
      china: china,
      hongkong: hongkong,
      india: india,
      japan: japan,
      malaysia: malaysia,
      philippines: philippines,
      singapore: singapore,
      selectedLayout: 'imageFirst',
      title: '',
      regions: [],
      selectedRegions: [],
      startDate: '',
      endDate: '',
      loading: false,
      body: '',
      editor: '',
      imageUploadedPath: '',
      selectAll: false,
    };
  },
  mounted() {
    this.getRegions();
  },
  methods: {
    charLimit() {
      return this.title.length == 255 ? 'red' : 'inherit';
    },
    getRegions() {
      this.loading = true;
      axios
        .get(this.$hostName + '/getRegions')
        .then((response) => {
          this.regions = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });

      this.initializeEditors();
    },

    initializeEditors() {
      //auto populate date fields to current date
      let current = new Date();
      let currentDate = `${current.getFullYear()}-${current.toLocaleString(
        'en',
        { month: '2-digit' }
      )}-${current.toLocaleString('en', { day: '2-digit' })}`;

      this.startDate = currentDate;
      this.endDate = currentDate;
      
      //setting min value of end date
      let endDateEle = document.getElementById('endDateEle');
      endDateEle.min = currentDate;
      // this.endDate.min = currentDate;

      console.log(
        'start date, end date: ' + this.startDate + ' ' + this.endDate
      );

      this.body = '';
      console.log('hostname: ' + this.$hostName);
      const quill = new Quill(this.$refs.editor, {
        theme: 'snow',
        // formats: ["bold", "italic", "underline", "strike", "image"],
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['image'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'],
          ],
        },
      });

      let host = this.$hostName;

      this.editor = quill;
      this.editor.root.style.height = '320px';
      //code to record editor content

      quill.on('text-change', () => {
        this.body = quill.root.innerHTML;
        // console.log("Body: " + this.body);
      });

      var toolbar = quill.getModule('toolbar');
      // var hostName = this.$hostName;
      toolbar.addHandler('image', function () {
        console.log('hostname inside handler: ' + host);
        const range = this.quill.getSelection();
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();
        // input.onchange = () => {
        //   this.loadImage(range, input);
        // };
        input.onchange = function () {
          // console.log("Input image: " + range.index + input);
          var file = input.files[0];
          var formData = new FormData();
          formData.append('image', file);
          formData.append('url', process.env.VUE_APP_ANNOUNCEMENT_URL);
          formData.append(
            'image_path',
            process.env.VUE_APP_ANNOUNCEMENT_IMAGE_PATH
          );
          axios
            .post(host + '/upload-image', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then((response) => {
              // console.log(response);
              // let imagePath = response.data.path;
              this.imageUploadedPath = response.data.path;
              console.log('image path inside call: ' + this.imageUploadedPath);

              quill.setSelection(range.index, 1);
              quill.updateContents(
                new Delta()
                  .retain(range.index)
                  .delete(1)
                  .insert({ image: this.imageUploadedPath })
              );

              const images = document.querySelectorAll('img');
              images.forEach((image) => {
                // Do something with each image element

                image.style.maxHeight = '300px';
                image.style.maxWidth = '534px';
              });
            })
            .catch((error) => console.error(error));
        };
      });
    },

    saveAnnouncement() {
      console.log('body: ',this.body.trim().length);
      if (this.title.trim().length == 0) {
        Swal.fire({
          icon: 'error',
          title: 'Please enter title!',
          text: 'Title can not be empty',
        });
      } else if (this.selectedRegions.length == 0) {
        Swal.fire({
          icon: 'error',
          title: 'Please select atleast one region!',
          text: 'Regions can not be empty',
        });
      } else if ((this.editor.root.innerText == 0) && !this.checkForImgTags(this.body)) {
        Swal.fire({
          icon: 'error',
          title: 'Please enter body for the announcement!',
          text: 'Body can not be empty for the announcement',
        });
      } else if (!this.startDate || !this.endDate) {
        Swal.fire({
          icon: 'error',
          title: 'Please select start and/or end dates!',
          text: 'Start and/or End Dates can not be empty',
        });
      } else {
        if (this.$refs.form.checkValidity()) {
          const formData = new FormData(this.$refs.form);

          //getting matches for all urls in editor after image insert
          let regex = /<img\b[^>]*src=['"]([^'"]+)['"][^>]*>/g;
          let matches = this.body.match(regex);
          let urls = [];
          console.log('Body match' + matches);
          if (matches != null) {
            urls = matches.map(
              (match) => match.match(/src=['"]([^'"]+)['"]/)[1]
            );
          }

          console.log(urls);

          //using only the first image
          // this.imageUploadedPath = urls[0];

          //splitting editor content such that image is excluded and text joined with: ..img..
          var body = this.body.split(/<img\b[^>]*>/g).join('..img..');
          console.log('body: ' + body);

          formData.append('body', body);

          this.selectedRegions.forEach((regionId) => {
            formData.append('region_ids[]', regionId);
          });

          console.log('URL length: ' + urls.length);
          if (urls.length > 0) {
            urls.forEach((url) => {
              formData.append('image[]', url);
            });
          }

          console.log('img :' + urls);

          //storing announcement
          axios
            .post(this.$hostName + '/storeAnnouncement', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              console.log(response);
              Swal.fire({
                icon: 'success',
                title: 'Announcement Created',
                text: 'The announcement has been successfully created!',
              });

              this.$router.push({
                name: 'announcements',
              });
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          this.$refs.form.reportValidity();
        }
      }
    },

    toggleAllRegions() {
      if (this.selectAll) {
        this.selectedRegions = this.regions.map((region) => region.id);
      } else {
        this.selectedRegions = [];
      }

      console.log('regions: ' + this.selectedRegions);
    },

    extractTextFromHtml(htmlstring) {
      let element = document.createElement('div');
      element.innerHTML = htmlstring;
      return element.textContent || element.innerText || '';
    },

    checkForImgTags(htmlString) {
      let regex = /<img[^>]*>/gi;
      let matches = htmlString.match(regex);
      // console.log("IMG TAGS: ", matches);

      return matches ? true : false;
    },

    firePreview() {
      const previewData = {
        title: this.title,
        body: this.editor.root.innerHTML,
      };

      this.$emit('show-preview', previewData);
    },

    goBack() {
      this.$router.go(-1);
    },

    getRegionsImage(name) {
      switch (name) {
        case 'Australia':
          return australia;
        case 'China':
          return china;
        case 'Hong Kong':
          return hongkong;
        case 'India':
          return india;
        case 'Japan':
          return japan;
        case 'Malaysia':
          return malaysia;
        case 'Philippines':
          return philippines;
        case 'Singapore':
          return singapore;
      }
    },

    isPreviewDisabled() {
      if (
        this.body.length == 0 ||
        this.body === '<p><br></p>' ||
        this.title.trim().length == 0
      ) {
        return true;
      }
      return false;
    },

    // loadImage(range, input) {
    // const file = input.files[0];
    // const formData = new FormData();
    // formData.append("image", file);
    // axios
    //   .post(this.$hostName + "/upload-image", formData, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   })
    //   .then((response) => {
    //     console.log(response);
    //     let imagePath = response.data.path;
    //     this.quill.setSelection(range.index, 1);
    //     this.quill.updateContents(
    //       new Delta()
    //         .retain(range.index)
    //         .delete(1)
    //         .insert({ image: imagePath })
    //     );
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.snow.css";

.create-announcement {
  font-family: Montserrat;
  max-width: 86vw;
  margin: 0px auto;
  margin-top: 10px;
  // border: 1px solid black;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 0px;
  width: 70%;
  min-width: 400px;
}

.flex-top-align {
  display: flex;
  align-items: top;
}

h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

label {
  font-weight: bold;
}

input[type="text"],
input[type="date"],
select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

input[type="file"] {
  display: block;
  margin-top: 5px;
}

// textarea {
//   padding: 8px;
//   border: 1px solid #ccc;
//   border-radius: 4px;
//   width: 100%;
//   min-height: 100px;
// }

.buttons {
  display: flex;
  justify-content: flex-end;
}

button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: 2px solid #007bff;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
  transition: 0.4s;
}

.preview {
  margin: 20px auto;
  margin-bottom: 0px;

  p {
    font-weight: bold;
  }
}

.preview-btn {
  // border: 1px solid black;
  background-color: transparent;
  color: black;
  border: 1.5px solid rgb(185, 185, 185);
}

.preview-btn:hover {
  background-color: #e7e7e7;
  border: 1.5px solid rgb(185, 185, 185);
}
</style>
